
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.95645 5.14514C3.29442 5.14514 1.13682 7.31851 1.13682 10C1.13682 12.6815 3.29442 14.8549 5.95645 14.8549H14.0436C16.7056 14.8549 18.8632 12.6815 18.8632 10C18.8632 7.31851 16.7056 5.14514 14.0436 5.14514H5.95645ZM0 10C0 6.68607 2.66657 4 5.95645 4H14.0436C17.3334 4 20 6.68607 20 10C20 13.3139 17.3334 16 14.0436 16H5.95645C2.66657 16 0 13.3139 0 10ZM5.95746 7.85783C4.78296 7.85783 3.83084 8.81691 3.83084 10C3.83084 11.1831 4.78296 12.1422 5.95746 12.1422C7.13196 12.1422 8.08407 11.1831 8.08407 10C8.08407 8.81691 7.13196 7.85783 5.95746 7.85783ZM2.69402 10C2.69402 8.18447 4.15511 6.7127 5.95746 6.7127C7.7598 6.7127 9.2209 8.18447 9.2209 10C9.2209 11.8155 7.7598 13.2873 5.95746 13.2873C4.15511 13.2873 2.69402 11.8155 2.69402 10Z","fill":"#A1AAC6"}})])
          )
        }
      }
    